import styled from 'styled-components';
import { TableBase } from 'features/shared/ui/Table';
import { ReactComponent as ExclamationIcon } from './ExclamationIcon.svg';

export const Table = styled(TableBase)`
  th {
    background: #f4f5f6;
  }

  thead tr:first-child th {
    height: 45px;
  }

  thead tr:nth-child(2) {
    height: 72px;
  }

  tfoot td:first-child {
    text-align: start;
    padding-left: 16px;
  }
`;

export const Legend = styled.div`
  padding: 16px;
  font-size: 14px;
  line-height: 20px;
  color: rgba(9, 21, 38, 0.6);
  background: rgba(9, 21, 38, 0.07);
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  width: 889px;
  b {
    font-weight: bold;
  }
`;

export const Exclamation = styled(ExclamationIcon)`
  path {
    fill: #ff6962;
  }
`;
